import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Sivukoko',
	PageOrientation: 'Sivun suunta',
	Format: 'Muoto',
	DPI: 'DPI',
	Generate: 'Generoi',
	LanguageName: 'Suomalainen',
	LanguageCode: 'fi'
};

export default translation;
